/**
 * attachmentChunkStore: manifest path.
 *
 * The one place the manifest object's Storage path is spelled. Contract surface
 * — the version callables, the sweep, the web reader and the rules tests all
 * name this path — and determined entirely by the reserved `versionId`, so
 * `beginAttachmentVersion` can return it before any bytes exist.
 */

/** Storage path of one manifest: `attachments/{fileUid}/manifests/{versionId}`. */
export const attachmentManifestPath = (fileUid: string, versionId: string): string =>
  `attachments/${fileUid}/manifests/${versionId}`;
